import React, { memo, useMemo, useState } from 'react';
import * as styles from './LinkCardV2.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import RedNumberText from '../../RedNumberText/RedNumberText';
import { PLATFORM_ICON_MAP } from '../../V2/icons';
import useInAppBrowser from '../../../hooks/useInAppBrowser';
import { DISCLAIMER_PLATFORMS } from '../../../constants';
import LinkDisclaimer from '../../LinkDisclaimer/LinkDisclaimer';

const LinkCardV2 = ({ linkData }) => {
  const [isDisclaimerVisible, setIsDisclaimerVisible] = useState(false);

  const {
    platform,
    platformTitle,
    link: url,
    icon,
    backgroundColor,
    backgroundImage,
  } = linkData;

  const platformIcon = useMemo(
    () =>
      platform ? (
        PLATFORM_ICON_MAP[platform]()
      ) : (
        <GatsbyImage
          image={icon}
          alt="Background image"
          className={styles.customLinkIcon}
        />
      ),
    [platform, icon]
  );

  const cardBackgroundImage = useMemo(
    () => getImage(backgroundImage),
    [backgroundImage]
  );

  const shouldShowDisclaimer = useMemo(
    () => DISCLAIMER_PLATFORMS.includes(platform?.toLowerCase()),
    [platform]
  );

  const { handleLinkClick } = useInAppBrowser({ url });

  const Link = ({ children }) => (
    <a
      className={styles.linkCardContainer}
      href={url}
      target="_blank"
      rel="noreferrer"
      onClick={handleLinkClick}
    >
      {children}
    </a>
  );

  const CardWrapper = ({ children }) =>
    shouldShowDisclaimer ? (
      <button
        className={styles.linkButton}
        onClick={() => setIsDisclaimerVisible(true)}
      >
        {children}
      </button>
    ) : (
      <Link>{children}</Link>
    );

  return (
    <CardWrapper>
      <div className={styles.linkCard} style={{ backgroundColor }}>
        {backgroundImage && (
          <div className={styles.linkCardBackground}>
            <GatsbyImage
              image={cardBackgroundImage}
              alt="Link Background image"
              className={styles.linkCardBackgroundImage}
            />
          </div>
        )}

        {isDisclaimerVisible && <LinkDisclaimer url={url} v2 />}

        {!isDisclaimerVisible && (
          <div className={styles.linkCardContent}>
            <div className={styles.linkCardIcon}>{platformIcon}</div>

            <p className={styles.linkCardTitle}>
              <RedNumberText {...platformTitle} />
            </p>
          </div>
        )}
      </div>
    </CardWrapper>
  );
};

export default memo(LinkCardV2);
